const objectToArray = (obj, sortingArray) => {
  let objectsArray = Object.keys(obj).map(function(keyField) {
    return obj[keyField]
  })
  const result = []

  sortingArray.forEach((key) => {
    let found = false
    objectsArray = objectsArray.filter((item) => {
      if (!found && item.id === key) {
        result.push(item)
        found = true
        return false
      } else return true
    })
  })

  return result
}

export default objectToArray
